import { DragOverlay } from '@dnd-kit/core';
import { cx } from '@linaria/core';
import { useComponentFrameworkState } from '@provider/component-framework';
import { IsomorphicPortal } from '@utils/react';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { getAudienceForTask } from '../../utils/get-audience-for-task.js';
import { taskSelectors } from '../organism.task/_task.selectors.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../organism.task/hook.task-breakpoints.js';
import { dragOverlay } from './_drag-overlay.style.js';
import { jsx } from 'react/jsx-runtime';

function OpgavekompleksetTaskDragOverlay(props) {
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector ? document.querySelector(targetSelector) : undefined;
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    target: target,
    children: /*#__PURE__*/jsx(DragOverlay, {
      style: {
        zIndex: 1000000
      },
      ...props,
      children: /*#__PURE__*/jsx(Content, {
        className: props.className,
        task: props.task,
        children: props.children
      })
    })
  });
}
function Content(props) {
  const component = useOpgavekompleksetComponent();
  const isTiny = useMatchTaskBreakpoint(taskBreakpoints.tiny);
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const isTablet = useMatchTaskBreakpoint(taskBreakpoints.tablet);
  const isDesktop = useMatchTaskBreakpoint(taskBreakpoints.desktop);
  const audience = getAudienceForTask(props.task, component.data.layout?.type);
  return /*#__PURE__*/jsx("div", {
    className: cx(taskSelectors.breakpoints.className, dragOverlay, props.className),
    "data-tiny": isTiny,
    "data-mobile": isMobile,
    "data-tablet": isTablet,
    "data-desktop": isDesktop,
    "data-audience": audience,
    "data-reapply-font-scales": true,
    children: props.children
  });
}

export { OpgavekompleksetTaskDragOverlay };
//# sourceMappingURL=_drag-overlay.js.map
